export const generativeAiAgentIdExecutionStats = "/generative_ai/agent/:id/execution_stats";
